import { usePopUpMessage } from '@hb/react'
import { ConsentFormStatusVersion, DeleteConsentFormArgs, ErrorWithMessage } from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { useCallback } from 'react'
import { functions } from '../../../backend/functions/functions'
import { DeleteButton } from '../../Buttons/DeleteButton'

const deleteConsentForm = httpsCallable<DeleteConsentFormArgs>(functions, 'deleteConsentForm')
export const DeleteConsentFormButton = ({
  patientId,
  consentFormStatus,
}: {
  patientId: string | null
  consentFormStatus: ConsentFormStatusVersion
}) => {
  const { showError, showSuccess } = usePopUpMessage()
  const handleDelete = useCallback(async () => {
    try {
      if (!patientId) {
        showError('No patientId')
        return
      }
      await deleteConsentForm({ patientId, consentFormId: consentFormStatus.consentFormId })
      showSuccess('Consent form deleted')
    } catch (error: any) {
      showError('Error deleting consent form', (error as ErrorWithMessage).message)
    }
  }, [patientId, consentFormStatus, showError, showSuccess])
  if (consentFormStatus.signedOn) return null
  return (
    <DeleteButton
      borderRadius="full"
      size="sm"
      variant="ghost"
      onDelete={handleDelete}
      itemName="consent form"
    />
  )
}
